module.exports = __webpack_public_path__ + "static/assets/69112c76ba876b2748173a58be1a46f2.png";